import {Component, Input, OnInit} from '@angular/core';
import {Rate} from '../../api/model/reservation/rate/rate.model';
import {Hotel} from '../../api/model/hotel/hotel.model';

const DEFAULT_REFUNDABLE_POLICY_KEY = 'reservation.cancellation.policy.default.refundable';
const DEFAULT_NON_REFUNDABLE_POLICY_KEY = 'reservation.cancellation.policy.default.nonrefundable';

@Component({
  selector: 'cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.scss']
})
export class CancellationPolicyComponent implements OnInit {
  @Input() rate: Rate;
  @Input() messages;

  defaultCancellationPolicy: string;

  ngOnInit () {
    this.defaultCancellationPolicy = null;
    if (this.rate) {
      this._checkAndSetDefaultCancellationPolicies();
    }
  }

  private _checkAndSetDefaultCancellationPolicies () {
    if (this.rate.cancellationPolicy.primaryPolicy) {
      return;
    }
    if (this.rate.refundable) {
      this.defaultCancellationPolicy = this.messages[DEFAULT_REFUNDABLE_POLICY_KEY];
    } else {
      this.defaultCancellationPolicy = this.messages[DEFAULT_NON_REFUNDABLE_POLICY_KEY];
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/cancellation-policy/cancellation-policy.component.ts